import axios from "axios";
import Cookies from "js-cookie";
import store from "../redux/store";

const Axios = axios.create({
  baseURL: `${process.env.REACT_APP_PUBLIC_API_URL}/api`,
  headers: {
    Accept: "application/json",
  },
});

Axios.interceptors.request.use(
  (config) => {
    const state = store.getState();
    const tenantSlug = process.env.REACT_APP_PUBLIC_CODE;
    const isLogin = config.url?.includes("/auth/login");

    // Get context from Redux state
    const tenantId = state.auth?.tenantId || state.auth?.user?.tenant_id;
    const organizationId = state.auth?.organizationId || state.auth?.user?.current_organization_id;

    // ✅ LOGIN → SEND SLUG IN BODY ONLY
    if (isLogin && tenantSlug) {
      if (config.data instanceof FormData) {
        config.data.append("slug", tenantSlug);
      } else if (config.data && typeof config.data === "object") {
        config.data = {
          ...config.data,
          slug: tenantSlug,
        };
      }
    }

    // ✅ OTHER REQUESTS → INJECT TENANT AND ORGANIZATION IDS INTO PAYLOAD/PARAMS
    if (!isLogin) {
      // Inject into Params (GET/DELETE)
      if (!config.params) config.params = {};
      if (tenantSlug && !config.params.slug) config.params.slug = tenantSlug;
      if (tenantId && !config.params.tenant_id) config.params.tenant_id = tenantId;
      if (organizationId && !config.params.organization_id) config.params.organization_id = organizationId;

      // Inject into Data (POST/PUT/PATCH)
      if (config.data) {
        if (config.data instanceof FormData) {
          if (tenantSlug && !config.data.has("slug")) config.data.append("slug", tenantSlug);
          if (tenantId && !config.data.has("tenant_id")) config.data.append("tenant_id", tenantId);
          if (organizationId && !config.data.has("organization_id")) config.data.append("organization_id", organizationId);
        } else if (typeof config.data === "object") {
          config.data = {
            ...(tenantId && !config.data.tenant_id ? { tenant_id: tenantId } : {}),
            ...(organizationId && !config.data.organization_id ? { organization_id: organizationId } : {}),
            ...(tenantSlug && !config.data.slug ? { slug: tenantSlug } : {}),
            ...config.data,
          };
        }
      }

      // ✅ TOKEN (Protected routes only)
      const token =
        state.auth?.token || localStorage.getItem("login_token") || Cookies.get("login_token");

      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);
Axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // If the error response status is 401 (Unauthorized)
    if (error.response && error.response.status === 401) {
      // Don't redirect if we're already on the login page or if it's a login request
      const isLoginRequest = error.config.url?.includes("/auth/login");

      if (!isLoginRequest) {
        // Clear all auth-related storage
        localStorage.removeItem("login_token");
        localStorage.removeItem("authState");
        localStorage.removeItem("persist:root");
        Cookies.remove("login_token");

        // Redirect to login page
        if (typeof window !== "undefined") {
          window.dispatchEvent(new Event("force-logout"));
        }
      }
    }

    return Promise.reject(error);
  },
);

export default Axios;
